"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeManagementSection = exports.ADD_TIME_SEGMENT_LINK_TEST_ID = void 0;
const Col_1 = require("@amzn/atoz-web/Col");
const Row_1 = require("@amzn/atoz-web/Row");
const Icons_1 = require("@amzn/atoz-web/Icons");
const Link_1 = require("@amzn/atoz-web/Link");
const react_1 = __importDefault(require("react"));
const SubmitModalContent_web_1 = require("../SubmitModalContent.web");
const TimeSegment_web_1 = require("./TimeSegment.web");
const TotalHours_web_1 = require("./TotalHours.web");
const SelfClassification_1 = require("../../../../../components/HourlyBreakdown/SelfClassification");
exports.ADD_TIME_SEGMENT_LINK_TEST_ID = 'add-time-segment-link';
const TimeManagementSection = (props) => {
    const renderTimeSegments = () => props.payDataList.map((payData, payDataIndex) => (react_1.default.createElement(TimeSegment_web_1.TimeSegment, { key: `timeSegment-${payDataIndex}`, payData: payData, payDataIndex: payDataIndex, setPayDataList: props.setPayDataList, payCodePolicyInfo: props.payCodePolicyInfo, isWECoreSelfClassification: props.isWECoreSelfClassification, isUpdateSelfClassification: props.isUpdateSelfClassification, defaultSelectedPayCode: (0, SubmitModalContent_web_1.getDefaultSelectedPayCode)(props.payCodePolicyInfo, props.payCodeToClassify) })));
    const renderTimeSegmentsATPlus = () => props.payCodeList.map((payCodeSummary, payDataIndex) => (react_1.default.createElement(TimeSegment_web_1.TimeSegment, { key: `timeSegment-${payDataIndex}`, payCodeSummary: payCodeSummary, payDataIndex: payDataIndex, setPayCodeList: props.setPayCodeList, payCodesInfo: props.payCodesInfo, isWECoreSelfClassification: props.isWECoreSelfClassification, isUpdateSelfClassification: props.isUpdateSelfClassification, defaultSelectedPayCode: (0, SelfClassification_1.getDefaultSelectedPayCodeATPlus)(props.payCodesInfo, props.payCodeToClassify) })));
    const renderAddTimeSegmentLink = () => {
        const shouldRender = props.isWECoreSelfClassification
            ? props.payDataList.length < 7
            : props.payCodeList.length < 7;
        return (shouldRender && (react_1.default.createElement(Row_1.Row, null,
            react_1.default.createElement(Link_1.Link, { dataTestId: exports.ADD_TIME_SEGMENT_LINK_TEST_ID, icon: react_1.default.createElement(Icons_1.IconPlusCircle, null), iconPosition: Link_1.LinkIconPosition.Leading, onClick: () => {
                    props.isWECoreSelfClassification
                        ? addPayData(props.setPayDataList, props.selectedDate, props.payCodePolicyInfo, props.payCodeToClassify)
                        : addPayCode(props.setPayCodeList, props.selectedDate, props.payCodesInfo, props.payCodeToClassify);
                }, fontSize: "T200", textDecoration: "none" }, "Add time segment"))));
    };
    return (react_1.default.createElement(Col_1.Col, { gridGap: "S300" },
        props.isWECoreSelfClassification
            ? renderTimeSegments()
            : renderTimeSegmentsATPlus(),
        renderAddTimeSegmentLink(),
        react_1.default.createElement(TotalHours_web_1.TotalHours, { totalHoursString: props.totalHoursString })));
};
exports.TimeManagementSection = TimeManagementSection;
const addPayData = (setPayDataList, selectedDate, payCodePolicyInfo, payCodeToClassify) => {
    setPayDataList((payDataList) => [
        ...payDataList,
        (0, SubmitModalContent_web_1.getDefaultPayDataFromSelectedDate)(selectedDate, payCodePolicyInfo, payCodeToClassify)
    ]);
};
const addPayCode = (setPayCodeList, selectedDate, payCodesInfo, payCodeToClassify) => {
    setPayCodeList((payCodeList) => [
        ...payCodeList,
        (0, SelfClassification_1.getDefaultPayCodeSummaryFromSelectedDate)(selectedDate, payCodesInfo, payCodeToClassify)
    ]);
};
